export enum NOTE_INTERACTION_TYPE_ENUM {
  NEW_ANNOTATION = 'New Annotation',
  SAVE_ANNOTATION = 'Save Annotation',
  EDIT_ANNOTATION = 'Edit Annotation',
  DELETE_ANNOTATION = 'Delete Annotation',
  LIST_ANNOTATIONS = 'List Annotation',
  UPDATE_DRAFT = 'Update Draft',
}
